import { useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useConsentBanner } from 'src/app/navigation-provider';
import { toggleFeedbackButton } from 'src/redux/global/actions/toggle-feedback-button';
import { toggleKeyboardShortcutMenu } from 'src/redux/global/actions/toggle-keyboard-shortcut-menu';
import { getCombinedBannerAndHorizontalNavHeight } from 'src/selectors/global-selectors';
import { BucketState } from 'src/types/state';

// includes redux actions that are used by different parts of nav. Eventually
// we can hopefully remove this dependence on redux and dispatching actions. In the
// these selectors provide navigation state data
export function useNavActions() {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      onKeyboardShortcutsActivated: () => {
        dispatch(toggleKeyboardShortcutMenu(true));
      },
      onFeedbackModalOpen: () => {
        dispatch(toggleFeedbackButton(true));
      },
    }),
    [dispatch]
  );
}

export function useNavHeight() {
  const { consentBannerHeight } = useConsentBanner()[0];
  const navHeight = useSelector((state: BucketState) =>
    getCombinedBannerAndHorizontalNavHeight(state, false, consentBannerHeight)
  );
  return navHeight;
}
